'use client';

import { styled } from '../../styles';
import { Typography } from '../Typography';

export const StyledDescription = styled.div(
  () =>
    ({
      display: 'flex',
      flexDirection: 'column',
    } as const),
);

export const DescriptionItem = styled.div(
  () =>
    ({
      display: 'flex',
      alignItems: 'flex-end',
    } as const),
);

export const DescriptionLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.text3,
}));

export const DescriptionValue = styled(Typography)(({ theme }) => ({
  color: theme.palette.text1,
}));

export const DescriptionSpacer = styled.div(({ theme }) => ({
  flex: 1,
  borderBottom: `1px dashed ${theme.palette.text4}`,
  margin: theme.spacing(0, 1, 1),
}));

export const DescriptionTip = styled(Typography)(({ theme }) => ({
  alignSelf: 'flex-end',
  marginTop: theme.spacing(2),
}));
